export const providers = ['RingCentral', 'Zoom', 'GoTo', 'Vonage', '8x8', 'Dialpad'];

export const comparisonRows = [
  { feature: 'User Minimum', values: ['1', '2–10', '1', '2–10', '1', '1'] },
  { feature: 'Analytics', values: providers.map(() => true) },
  { feature: 'Call Monitoring', values: providers.map(() => true) },
  { feature: 'Call Queue', values: providers.map(() => true) },
  { feature: 'Call Recording', values: providers.map(() => true) },
  { feature: 'Chat Functionality', values: providers.map(() => true) },
  { feature: 'eFax', values: providers.map(() => true) },
  { feature: 'IVR', values: providers.map(() => true) },
  { feature: 'Mobile App', values: providers.map(() => true) },
  { feature: 'Softphone App', values: providers.map(() => true) },
  { feature: 'Video Meetings', values: providers.map(() => true) },
  { feature: 'Voicemail Transcription', values: providers.map(() => true) },
  { feature: 'AI-Powered Features', values: providers.map(() => true) },
  { feature: 'AI Call/Meeting Transcription', values: providers.map(() => true) }
];

export const providerMatrixTabs = [
  {
    label: 'Core Features',
    rows: [
      { feature: 'User Minimum', values: ['1', '2–10', '1', '2–10', '1', '1'] },
      { feature: 'Analytics', values: [true, true, true, true, true, true] },
      { feature: 'Branded Caller ID', values: [true, true, true, true, true, true] },
      { feature: 'Call Monitoring', values: [true, true, true, true, true, true] },
      { feature: 'Call Queue', values: [true, true, true, true, true, true] },
      { feature: 'Call Recording', values: [true, true, true, true, true, true] },
      { feature: 'Chat Functionality', values: [true, true, true, true, true, true] },
      { feature: 'eFax', values: [true, true, true, true, true, true] },
      { feature: 'Hunt Group', values: [true, true, true, true, true, true] },
      { feature: 'IVR / Auto Attendant', values: [true, true, true, true, true, true] },
      { feature: 'Mass Notification', values: [true, false, false, false, true, false] },
      { feature: 'Mobile App', values: [true, true, true, true, true, true] },
      { feature: 'Paging Group', values: [true, false, true, false, true, false] },
      { feature: 'Screen Sharing', values: [true, true, true, true, true, true] },
      { feature: 'Softphone App', values: [true, true, true, true, true, true] },
      { feature: 'Video Meetings', values: [true, true, true, true, true, true] },
      { feature: 'Voicemail Transcription', values: [true, true, true, true, true, true] }
    ]
  },
  {
    label: 'AI Capabilities',
    rows: [
      { feature: 'AI Call/Meeting Transcription', values: [true, true, true, true, true, true] },
      { feature: 'AI Meeting Summaries', values: [true, true, true, true, true, true] },
      { feature: 'AI Receptionist / Virtual Agent', values: [true, true, true, true, false, true] },
      { feature: 'AI Coaching & Sentiment Insights', values: [true, true, false, true, true, true] }
    ]
  },
  {
    label: 'Compliance & Security',
    rows: [
      { feature: 'SOC 2', values: [true, true, true, true, true, true] },
      { feature: 'HIPAA (BAA available)', values: [true, true, true, true, true, true] },
      { feature: 'GDPR', values: [true, true, true, true, true, true] },
      { feature: 'ISO 27001', values: [true, true, true, true, true, true] },
      { feature: 'PCI DSS', values: [true, true, false, true, true, false] },
      { feature: 'FedRAMP (government tier)', values: [true, false, false, false, true, false] }
    ]
  },
  {
    label: 'CRM Integrations',
    rows: [
      { feature: 'Salesforce', values: [true, true, true, true, true, true] },
      { feature: 'HubSpot', values: [true, true, true, true, true, true] },
      { feature: 'Microsoft Dynamics 365', values: [true, true, true, true, true, true] },
      { feature: 'Zendesk', values: [true, true, true, true, true, true] },
      { feature: 'Zoho CRM', values: [true, true, true, true, true, true] },
      { feature: 'ServiceNow', values: [true, true, false, true, true, false] }
    ]
  }
];

export const faqs = [
  {
    question: 'What is a vendor-neutral technology advisor?',
    answer: 'An advisor who evaluates multiple providers against your needs instead of starting with one carrier’s product. Cambia compares fit, cost, integrations, support, and implementation risk before making a recommendation.'
  },
  {
    question: 'Does it cost more to go through Cambia instead of buying direct?',
    answer: 'Typically, no. Provider pricing is generally comparable to direct pricing, while Cambia adds independent evaluation and ongoing account support. We explain commercial relationships clearly before you decide.'
  },
  {
    question: 'What’s included in a Tech Reality Check™?',
    answer: 'A review of current services and bills, interviews about business requirements, identification of cost and capability gaps, and a practical recommended path with no obligation to switch.'
  },
  {
    question: 'How is UCaaS different from a regular phone system?',
    answer: 'UCaaS combines business calling, video, messaging, fax, mobility, and administration in one cloud platform. A traditional phone system usually handles voice only and relies on on-site hardware.'
  },
  {
    question: 'Do you support businesses outside NYC?',
    answer: 'Yes. Cambia’s core service area is the NYC Tri-State region, Brooklyn, Queens, and roughly a 50-mile radius, but many cloud and wireless engagements can be handled remotely.'
  },
  {
    question: 'How long does it take to switch providers?',
    answer: 'Most SMB deployments take a few weeks, depending on locations, number porting, integrations, hardware, and training. Cambia builds the transition plan around business continuity rather than an arbitrary deadline.'
  }
];

export const navigation = [
  { label: 'UCaaS', to: '/ucaas' },
  { label: 'CCaaS', to: '/ccaas' },
  { label: 'Wireless', to: '/wireless' },
  { label: 'Compare', to: '/compare-providers' },
  { label: 'Provider Matrix', to: '/provider-matrix' },
  { label: 'About', to: '/about' },
  { label: 'Resources', to: '/resources' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Contact', to: '/contact' }
];